import { lazy } from "react";
import {
  KIOSK_ADD_INSURANCE,
  KIOSK_MAKE_PAYMENT,
  KIOSK_PATIENT_DATA,
  KIOSK_SEARCH_PATIENT,
} from "routes/paths";

const SearchPatient = lazy(() => import("pages/patient/SearchPatient"));
const PatientData = lazy(() => import("pages/patient/PatientData"));
const AddInsurance = lazy(() =>
  import("components/patient/AddInsurance/AddInsurance"),
);
const PatientPayment = lazy(() => import("pages/patient/PatientPayment"));

const kioskRoutes = [
  {
    path: KIOSK_SEARCH_PATIENT,
    isExact: true,
    component: SearchPatient,
  },
  {
    path: KIOSK_PATIENT_DATA,
    isExact: false,
    component: PatientData,
  },
  {
    path: KIOSK_ADD_INSURANCE,
    isExact: false,
    component: AddInsurance,
  },
  {
    path: KIOSK_MAKE_PAYMENT,
    isExact: false,
    component: PatientPayment,
  },
];

export default kioskRoutes;
